export function customSelect() {
    if ($("select").length) {
        jcf.setOptions("Select", {
            wrapNative: false,
            maxVisibleItems: 9
        });
        jcf.replaceAll();
    }
}



// WEBPACK FOOTER //
// ./assets/js/modules/customSelect.js